<template>
  <a-drawer
    placement="right"
    :visible="visible"
    :closable="true"
    :mask-closable="false"
    width="800"
    wrap-class-name="inquiry-filter-drawer"
    @close="onClose"
  >
    <div
      slot="title"
      class="title clearfix"
    >
      <h2 class="fl">
        {{ $t('message["960"]') }}
      </h2>
      <span
        class="more-btn btn-text fl"
        @click="openFilterConfig"
      >{{ $t('message["378"]') }}</span>
    </div>

    <a-spin
      :spinning="loading"
      class="form"
    >
      <a-form
        v-if="!loading && newFormData && newFormData.length"
        :form="form"
        :hide-required-mark="true"
        :class="{'en-form': isEnglish}"
      >
        <filter-item
          v-for="(item) in newFormData"
          :key="item.fileldkey"
          class="clearfix"
          :data="item"
          @change="onChangeItem"
        />
      </a-form>
    </a-spin>
    <div class="footer">
      <a-button
        type="primary"
        @click="handleOk"
      >
        {{ $t('message["915"]') }}
      </a-button>
      <a-button
        :style="{marginRight: '8px'}"
        @click="handleClear"
      >
        {{ $t('message["736"]') }}
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import eventBus from '@/lib/eventBus'
import { mapState, mapActions, mapMutations } from 'vuex'
import { jsonToBase64, base64ToJson } from '@/lib/utils'
import { getLang } from '@/lib/storage'
const FilterItem = () => import('./../filterItem/FilterItem')

export default {
  components: {
    FilterItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: ''
    },
    type: {
      type: [String, Number],
      default: ''
    },
    paramsType: {
      type: [String, Number],
      default: ''
    }
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      isVisible: false
    }
  },
  computed: {
    ...mapState('inquery/filterData', [
      'filterFormData',
      'loading',
      'filterResult',
      'filterStr'
    ]),
    query () {
      return this.$route.query
    },
    newFormData () {
      for (let item of this.filterFormData) {
        const { fieldkey, fieldtype } = item
        for (let key in this.filterResult) {
          if (fieldkey === key) {
            if (item.isneeded === 1) {
              item.isneeded = 0
            }

            let value
            if (fieldtype === 'radioinfo_type' && item.fieldconfig && item.fieldconfig.info_sign) {
              let { fieldvalue = [], info_sign: infosignValue = [] } = this.filterResult[key] || {}
              value = fieldvalue
              this.$set(item.fieldconfig.info_sign, 'fieldvalue', infosignValue)
            } else {
              value = this.filterResult[key] && this.filterResult[key].fieldvalue
            }
            this.$set(item, 'fieldvalue', value)
          }
        }
        if (!Object.keys(this.filterResult).length) {
          for (let item of this.filterFormData) {
            item.fieldvalue = ''
          }
        }
      }
      return this.filterFormData
    },
    issystem () {
      return this.$route.query.issystem
    },
    viewid () {
      return this.$route.query.viewid
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  watch: {
    async visible (val) {
      this.isVisible = val
      if (val) {
        this.$nextTick(() => {
          this.getQuery()
          if (this.filterStr) {
            this.setFilterResult(base64ToJson(this.filterStr))
          }
          document.body.style.overflow = 'hidden'
        })
      } else {
        document.body.style.overflow = 'auto'
      }
    }
  },
  created () {
    eventBus.$on('getQuery', this.getQuery)
  },
  beforeDestroy () {
    eventBus.$off('getQuery', this.getQuery)
  },
  methods: {
    ...mapActions('inquery/filterData', ['fetchQuery', 'setFilterResult', 'setFilterStr']),
    ...mapMutations('inquery/listData', ['SET_TABLE_SORT']),
    getLang,
    async getQuery () {
      const chain = await this.fetchQuery()
      chain
        .params({
          scope: this.from,
          type: this.paramsType
        })
        .fetch()
    },
    onChangeItem (value) {
      // console.log(value)
    },
    hide () {
      this.$emit('update:visible', false)
      this.setFilterResult({})
    },
    onClose () {
      this.hide()
    },

    // 点击筛选的确定按钮时，处理数据为 key: value 格式
    setFilterUrlData (type) {
      let obj = {}
      for (let item of this.filterFormData) {
        let one = {}
        one.fieldtype = item.fieldtype
        one.fieldkey = item.fieldtype
        one.fieldvalue = item.fieldvalue
        if (item.fieldtype === 'radioinfo_type') {
          const { fieldconfig = {} } = item || {}
          const { info_sign: infoSign = {} } = fieldconfig
          one.info_sign = infoSign.fieldvalue
        }
        obj[item.fieldkey] = one
      }
      return obj
    },

    async handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const urlFilters = this.setFilterUrlData()
          // 存 store
          this.setFilterStr(jsonToBase64(urlFilters))

          this.$router.push({
            name: 'InqueryList',
            query: {
              type: this.type,
              from: this.from,
              _t: new Date().getTime(),
              issystem: this.issystem,
              viewid: this.viewid,
              page: 1,
              limit: 10
            }
          })
          this.hide()
          this.SET_TABLE_SORT({ tableSort: {}, sorter: {} })
        }
      })
    },
    handleClear () {
      let { from = '', type = '', code = '' } = this.$route.query

      this.$router.push({
        name: 'InqueryList',
        query: {
          from,
          type,
          code,
          _t: new Date().getTime(),
          issystem: this.issystem,
          viewid: this.viewid,
          page: 1,
          limit: 10
        }
      })

      this.setFilterStr('')
      this.setFilterResult({})
      // eventBus.$emit('fetchInquiryList')
      this.hide()
    },
    openFilterConfig () {
      eventBus.$emit('showFilterConfig')
    }
  }
}
</script>

<style lang="scss" scoped>
  .en-form::v-deep {
  .ant-form-item-label {
    width: 200px;
    text-overflow: ellipsis;
    label {
      white-space: nowrap;
    }
  }
  .ant-form-item-control-wrapper {
    padding-left: 200px;
  }
   .ant-form-item-label label::after{
    content: '';
  }
  .ant-form-item-label::after {
    content: ':';
    position: absolute;
    left: 182px;
    top: 0;
    color: #666;
  }
}
</style>
<style lang="scss">
.inquiry-filter-drawer {
  .ant-drawer-close {
    top: 44px;
    right: 40px;
    .ant-drawer-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 32px;
      color: #ccc;
    }
  }
  .ant-drawer-content-wrapper {
    overflow-y: auto;
  }
  .ant-drawer-content {
    border-bottom: none;
  }
  .ant-drawer-header {
    padding: 32px 40px 40px;
    border-bottom: none;
  }
  .ant-drawer-title h2 {
    font-size: 32px;
    height: 56px;
    line-height: 56px;
    font-weight: 600;
  }
  .ant-drawer-body {
    padding: 0 40px 70px;
  }
  .ant-form-item-label {
    width: 146px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ant-form-item-control-wrapper {
    padding-left: 146px;
  }
  .more-btn {
    margin: 24px 0 0 16px;
    font-size: 14px;
  }
  .footer {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 99;
    width: 783px;
    padding: 16px 0 16px 180px;
    background-color: #fff;
    border-top: 1px solid $gray4;
  }
}
</style>
